<template>
  <div :class="['tag__item', 'd-flex', 'm-1', {repeated: repeated === tag}, {'tag--locked': locked}]">
    <span :class="[{'mr-3': !locked} ,'noselect']">
      {{ tag }}
    </span>
    <button
      v-if="!locked"
      type="button"
      tabindex="-1"
      @click="() => onRemove(tag)"
    >
      <font-awesome-icon
        :icon="['far', 'times']"
        size="xs"
        class="tag__times"
      />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    tag: [String, Number],
    onRemove: Function,
    repeated: [String, Number],
    locked: Boolean
  }
}
</script>

<style lang="scss" scoped>
  .tag {
    &__item {
      padding: 2px 7px 2px 4px;
      color: $royalpurple-dark;
      background-color: #cdcdd2;
      border-radius: 2px;
    }
    &__times {
      color: $royalpurple-dark;
    }
    &--locked {
      padding-right: 4px;
    }
  }
  button {
    margin: 0;
    border: 0;
    padding: 0;
    background-color: transparent;
    &:hover, &:active, &:focus {
      outline: unset;
    }
    svg {
      vertical-align: unset;
    }
  }
  .repeated {
    background-color: $danger;
    span, .tag__times {
      color: $white;
    }
  }
</style>
